/*
  Hook will check if there is an existing location.key before redirecting
  If the key is not present, we assume that the user had opened a new tab and hook will return navigate (redirects to the home page)
  If the key is present, we assume they came from page within our app and hook will return navigate(-1) (redirects to the previous page)
*/

import * as React from 'react';
import {
  useNavigateLegacy as useNavigate,
  useLocationLegacy as useLocation,
} from '@leagueplatform/routing';

export const useGoBack = (fallbackLocation?: string) => {
  const location = useLocation();
  const navigate = useNavigate();

  const goBack = React.useCallback(() => {
    if (!location.key || location.key === 'default') {
      return navigate(fallbackLocation ?? '/');
    }

    return navigate(-1);
  }, [fallbackLocation, location.key, navigate]);

  return goBack;
};
